import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49b39700")

_pushScopeId("data-v-49b39700")
const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "error-toast" }
const _hoisted_3 = { class: "error-toast" }
_popScopeId()

import { useStore } from "@/store/store";
import { onMounted, onBeforeUnmount, computed } from "vue";
import { MutationTypes } from "./store/mutation-types";
import { clearToastTimeouts } from "./services/error-management.service";
import PadelLateralTab from "./components/lateral-tab/PadelLateralTab.vue";
import { useRoute } from "vue-router";


export default _defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();

function initializeStore() {
  store.commit(MutationTypes.CLOSE_LOADER, null);
  store.commit(MutationTypes.SET_SHOW_ERROR, null);
}


onMounted(function () {
  initializeStore();
});

onBeforeUnmount(() => {
  // Clear all pending toast timeouts to prevent DOM manipulation errors
  clearToastTimeouts();
});

const loader = computed(() => {
  return store.getters.getLoader;
});
const showSuccess = computed(() => {
  return store.getters.getShowSuccess;
});
const showError = computed(() => {
  return store.getters.getShowError;
});
const hideError = () => {
  store.commit(MutationTypes.SET_SHOW_ERROR, null);
};

return (_ctx: any,_cache: any) => {
  const _component_PadelToast = _resolveComponent("PadelToast")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode(_component_PadelToast, {
        message: _unref(showSuccess),
        onCloseClicked: _cache[1] || (_cache[1] = ($event: any) => (hideError())),
        type: "primary",
        icon: "check_circle"
      }, null, 8, ["message"])
    ], 512), [
      [_vShow, _unref(showSuccess)]
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode(_component_PadelToast, {
        message: _unref(showError),
        onCloseClicked: _cache[2] || (_cache[2] = ($event: any) => (hideError()))
      }, null, 8, ["message"])
    ], 512), [
      [_vShow, _unref(showError)]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_Loader)
    ], 512), [
      [_vShow, _unref(loader)]
    ]),
    (!_unref(route).meta.public && _unref(store).getters.getUser.role === 'CLUB_MANAGER')
      ? (_openBlock(), _createBlock(PadelLateralTab, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: { 'view-main-container': !_unref(route).meta.public }
    }, [
      _createVNode(_component_router_view)
    ], 2)
  ]))
}
}

})